<?xml version="1.0" encoding="UTF-8"?>
<svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="ym-1" stroke="currentColor" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Press-kit_def" transform="translate(-937.000000, -620.000000)">
            <g id="group-3" transform="translate(320.000000, 264.000000)">
                <g id="jx-4" transform="translate(460.000000, 138.000000)">
                    <g id="group" transform="translate(0.000000, 200.000000)">
                        <g id="download" transform="translate(157.000000, 18.000000)">
                            <rect id="jx" fill-opacity="0.01" fill="#FFFFFF" fill-rule="nonzero" x="0" y="0"></rect>
                            <polyline id="lj1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" points="3 12.00415 3 21 21 21 21 12"></polyline>
                            <polyline id="lh2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" points="16.5 11.5 12 16 7.5 11.5"></polyline>
                            <line x1="11.99585" y1="3" x2="11.99585" y2="16" id="lh3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></line>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>